import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const CaretDouble = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M7.70032081,11.7766835 L7.76719422,11.8271623 L12,15.4546667 L16.2328058,11.8271623 C16.5123563,11.5875475 16.933223,11.6199219 17.1728378,11.8994724 C17.3940206,12.1575191 17.3834494,12.5359771 17.1606402,12.781138 L17.1005276,12.8395044 L12.4338609,16.8395044 C12.2050061,17.0356657 11.8763747,17.0520125 11.6308904,16.8885448 L11.5661391,16.8395044 L6.89947239,12.8395044 C6.61992182,12.5998896 6.58754746,12.179023 6.82716223,11.8994724 C7.0483451,11.6414257 7.42396744,11.5939907 7.70032081,11.7766835 Z M17.1728378,7.23280572 C17.3940206,7.4908524 17.3834494,7.86931042 17.1606402,8.11447133 L17.1005276,8.17283771 L12.4338609,12.1728377 C12.2050061,12.368999 11.8763747,12.3853458 11.6308904,12.2218781 L11.5661391,12.1728377 L6.89947239,8.17283771 C6.61992182,7.93322294 6.58754746,7.51235628 6.82716223,7.23280572 C7.0483451,6.97475905 7.42396744,6.92732405 7.70032081,7.11001677 L7.76719422,7.16049557 L11.9993333,10.7886667 L16.2328058,7.16049557 C16.5123563,6.9208808 16.933223,6.95325516 17.1728378,7.23280572 Z"
        id="path-1-caret-double"
      ></path>
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&amp;solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/controls/caret-down-double/line">
        <mask id="mask-2-caret-double" fill="white">
          <use xlinkHref="#path-1-caret-double"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
          xlinkHref="#path-1-caret-double"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-caret-double)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
